import { Icon20CopyOutline, Icon20DocumentOutline, Icon20WriteOutline } from '@vkontakte/icons';
import React, { type FC } from 'react';
import { EDIT_MENU_BUTTON_REDESIGN_PDF } from 'reactApp/appHelpers/featuresHelpers/features/editMenuButtonRedesign';
import { DropdownItemAction } from 'reactApp/ui/DropdownItemAction/DropdownItemAction';
import { DropdownList, DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { useDropdownList } from 'reactApp/ui/DropdownList/DropdownList.hooks';
import { MenuButton } from 'reactApp/ui/ReactViewer/ViewerMenu/MenuButton/MenuButton';

import styles from './PdfEditMenuButton.css';

interface Props {
    onPdfEdit: () => void;
    onPdfCopyEdit: () => void;
}

export const PdfEditMenuButton: FC<Props> = ({ onPdfEdit, onPdfCopyEdit }) => {
    const { controlRef, isOpen, open, close, findDropdownPosition } = useDropdownList<HTMLDivElement>({ offsetTop: 8 });

    const isEditPdfButtonRedesignEnabled = EDIT_MENU_BUTTON_REDESIGN_PDF;
    const displayText = isEditPdfButtonRedesignEnabled ? 'Редактировать' : undefined;
    const hint = isEditPdfButtonRedesignEnabled ? undefined : 'Редактировать';
    const originalText = isEditPdfButtonRedesignEnabled ? 'Оригинал' : 'Редактировать оригинал';
    const copyText = isEditPdfButtonRedesignEnabled ? 'Копию' : 'Редактировать копию';

    return (
        <>
            <MenuButton
                text={displayText}
                hint={hint}
                icon={<Icon20WriteOutline />}
                hasDropdown
                isDropdownOpen={isOpen}
                ref={controlRef}
                onClick={onPdfEdit}
                onDropdownClick={() => {
                    if (isOpen) {
                        close();
                    } else {
                        open();
                    }
                }}
                qaId="edit"
            />
            {isOpen && (
                <DropdownList
                    gaId="viewer-pdf-edit"
                    className={styles.list}
                    close={close}
                    closeOnResize
                    closeOnScroll
                    posX={0}
                    posY={0}
                    parentRef={controlRef}
                    theme={DropdownTheme.large}
                    calcPosition={findDropdownPosition}
                    list={[
                        {
                            text: originalText,
                            id: 'editOriginal',
                            className: styles.itemWrapper,
                            onClick: onPdfEdit,
                            icon: <Icon20DocumentOutline />,
                        },
                        {
                            text: copyText,
                            id: 'editCopy',
                            className: styles.itemWrapper,
                            onClick: onPdfCopyEdit,
                            icon: <Icon20CopyOutline />,
                        },
                    ]}
                    renderItem={(item) => <DropdownItemAction className={styles.item} text={item.text} />}
                />
            )}
        </>
    );
};
